import { getIsAfyaImaraProductsPending } from '../../../selectors/afyaImara/quote';
import {
    apiTransitionAfyaImaraProducts,
    setProductsValid,
    setProductsValue,
} from '../../../actions/afyaImara/quote';
import { getAccessToken } from '../../../selectors/afyaImara/payments';
import axios from 'axios';

export const getProductsService = (store, next, action) => {
    (async () => {
        if (!getIsAfyaImaraProductsPending(store.getState())) {
            store.dispatch(apiTransitionAfyaImaraProducts.pending());
            try {
                const resp = await getAllAfyaImaraProducts(store.getState());
                store.dispatch(setProductsValue(resp.data));
                store.dispatch(apiTransitionAfyaImaraProducts.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAfyaImaraProducts.failure());
                store.dispatch(setProductsValid(e));
            }
        }
    })();

    return next(action);
};

const getAllAfyaImaraProducts = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ke-afya-imara/products';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
